import React, { useEffect, Component } from 'react';
import Header from './components/layout/Header';
import Hero from './components/layout/Hero';
import TrustSection from './components/sections/TrustSection';
import ComparisonSection from './components/sections/ComparisonSection';
import VehicleRecommendations from './components/sections/VehicleRecommendations';
import FinalCTA from './components/sections/FinalCTA';
import LeadForm from './components/sections/LeadForm';
import FAQ from './components/sections/FAQ';
import Footer from './components/layout/Footer';
import WhatsAppButton from './components/ui/WhatsAppButton';
import FacebookPixel from './components/tracking/FacebookPixel';
import GHLChatWidget from './components/tracking/GHLChatWidget';
import MidPageCTA from './components/sections/MidPageCTA';
import { LanguageProvider } from './context/LanguageContext';
import { initAntiInspect } from './utils/antiInspect';
import { useEngagementTracking } from './hooks/useEngagementTracking';
export function App() {
  // Anti-inspect protection
  useEffect(() => {
    const cleanup = initAntiInspect();
    return cleanup;
  }, []);
  // Initialize engagement tracking (scroll depth & time on page)
  useEngagementTracking();
  // Script de redirección mejorado
  useEffect(() => {
    // Función para manejar el envío del formulario
    const handleFormSubmit = () => {
      console.log('Formulario enviado, configurando redirección de respaldo');
      // Establecer una bandera global para evitar redirecciones múltiples
      if (!(window as any).__FORM_SUBMIT_HANDLER_ATTACHED__) {
        ;
        (window as any).__FORM_SUBMIT_HANDLER_ATTACHED__ = true;
        // Configurar un respaldo de redirección después de 8 segundos
        setTimeout(() => {
          const formSubmitted = localStorage.getItem('formSubmitted');
          if (formSubmitted === 'true') {
            console.log('Ejecutando redirección de respaldo a WhatsApp');
            if (!(window as any).__REDIRECTED_AFTER_SUBMIT__) {
              ;
              (window as any).__REDIRECTED_AFTER_SUBMIT__ = true;
              // Backup redirect to WhatsApp (matches hybrid funnel)
              window.location.href = 'https://wa.me/18572715381?text=' + encodeURIComponent('Hola Pedro, acabo de enviar mi solicitud en la web.');
            }
          }
        }, 8000);
      }
    };
    // Adjuntar el manejador de eventos al formulario
    const form = document.getElementById('lead-form');
    if (form && form instanceof HTMLFormElement) {
      form.addEventListener('submit', handleFormSubmit, {
        once: true
      });
    }
    // Limpieza al desmontar
    return () => {
      if (form && form instanceof HTMLFormElement) {
        form.removeEventListener('submit', handleFormSubmit);
      }
    };
  }, []);
  return <LanguageProvider data-id="element-0" data-mp="2xtlprdxr0sjl">
      <div className="font-sans text-[#0B1220] bg-[#F8FAFC] min-h-screen w-full" data-id="element-1" data-mp="2xssga57enoxr">
        <FacebookPixel data-id="element-2" data-mp="2svafj23jkg0u" />
        <GHLChatWidget data-id="element-3" data-mp="2stzdp7tnpicd" />
        <Header data-id="element-4" data-mp="18e19rkmjbok1" />
        <main data-id="element-5" data-mp="18dhphx9ewo2u">
          <Hero data-id="element-6" data-mp="18czn0iw5pdmh" />
          <TrustSection data-id="element-7" data-mp="18cgf7v0805m6" />
          <ComparisonSection data-id="element-8" data-mp="18bydiiusgz6v" />
          <MidPageCTA data-id="element-9" data-mp="1d4rf4xuynreq" />
          <VehicleRecommendations data-id="element-10" data-mp="1d59j6gnv79x7" />
          <FAQ data-id="element-11" data-mp="1d6awysw9maim" />
          <LeadForm data-id="element-12" data-mp="yfv9t8kagsht" />
          <FinalCTA data-id="element-13" data-mp="ygd2xwbnmqli" />
        </main>
        <Footer data-id="element-14" data-mp="yheqv1drr7kn" />
      </div>
    </LanguageProvider>;
}